export default __webpack_public_path__ + "static/media/selected-plan-icon.180a3ce9.svg";